import { ExternalLink } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

/**
 * Button trigger that opens a full-page preview of Settings → Integrations
 * as seen on the Free plan, in a new tab. The full-page view lives at
 * /preview/free-plan-integrations and renders inside AppLayout so the
 * screenshot shows the real app chrome.
 */
export default function FreePlanIntegrationsPreview() {
  const { t } = useTranslation();
  return (
    <Button variant="outline" size="sm" className="gap-1.5" asChild>
      <a href="/settings?section=integrations&freePlanPreview=1" target="_blank" rel="noopener noreferrer">
        <ExternalLink className="h-3.5 w-3.5" />
        {t("credits.integrationsPreviewButton")}
      </a>
    </Button>
  );
}
